import { render } from "./SolutionCenterView.vue?vue&type=template&id=127ac65e&scoped=true"
import script from "./SolutionCenterView.vue?vue&type=script&lang=js"
export * from "./SolutionCenterView.vue?vue&type=script&lang=js"

import "./SolutionCenterView.vue?vue&type=style&index=0&id=127ac65e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127ac65e"]])

export default __exports__